import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { AxiosError } from 'axios'
import { toast } from 'sonner'
import { ROUTES } from '@/constants/routes'
import { BILLING_PORTAL_LOCALE } from '@/constants/subscription'
import { subscriptionService } from '@/services/subscription'

// the org is billed by quote: reactivation goes through the quote flow, not Stripe Checkout
const QUOTE_BILLED_STATUS = 409

export function useReactivateSubscription() {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)

  const reactivate = useCallback(async () => {
    if (isLoading) return
    setIsLoading(true)
    try {
      const baseUrl = import.meta.env.VITE_FRONTEND_URL ?? window.location.origin
      const { url } = await subscriptionService.createReactivationSession({
        success_url: `${baseUrl}${ROUTES.PAYMENT_SUCCESS}`,
        cancel_url: `${baseUrl}${ROUTES.DASHBOARD}`,
        locale: i18n.language?.startsWith('en')
          ? BILLING_PORTAL_LOCALE.EN
          : BILLING_PORTAL_LOCALE.FR,
      })
      // full page redirect: keep the loading state until the browser leaves
      window.location.href = url
    } catch (error) {
      const status = error instanceof AxiosError ? error.response?.status : undefined
      if (status === QUOTE_BILLED_STATUS) {
        toast.error(t('profile.licence.reactivateQuoteRequired'))
        navigate(ROUTES.CUSTOM_OFFER_FORM)
      } else {
        toast.error(t('profile.licence.reactivateError'))
      }
      setIsLoading(false)
    }
  }, [isLoading, i18n.language, navigate, t])

  return { reactivate, isLoading }
}
